import { i18n } from './../utils/i18n';
import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/Auth/LoginView.vue';
import DashboardView from '@/views/Auth/DashboardView.vue';
import { useAuthStore } from '@/stores/auth';
import { pingServer } from '@/services/api/auth';
import { storeToRefs } from 'pinia';
import { useToastStore } from '@/stores/toast';
import ReportPricingView from '@/views/ReportPricingView.vue';
import MaterialsView from '@/views/general/warehouse/materialsManagement/MaterialsView.vue';
import AssortmentsManagementView from '@/views/general/warehouse/assortmentsManagement/AssortmentsManagementView.vue';
import DivisionsView from '@/views/general/documents/DivisionsView.vue';
import MyDataDocumentsView from '@/views/general/documents/MyDataDocumentsView.vue';
import DocumentTypesView from '@/views/general/documents/documentTypesManagement/DocumentTypesView.vue';
import AlterCodeTypesView from '@/views/general/warehouse/AlterCodeTypesView.vue';
import CompetitorTypesView from '@/views/general/traders/CompetitorTypesView.vue';
import DocumentStatusesView from '@/views/general/documents/DocumentStatusesView.vue';
import PaymentTypesView from '@/views/general/documents/PaymentTypesView.vue';
import DynamicRangesView from '@/views/general/warehouse/DynamicRangesView.vue';
import AssortmentDetails from '@/views/general/warehouse/assortmentsManagement/AssortmentDetails.vue';
import DevicesView from '@/views/general/documents/devicesManagement/DevicesView.vue';
import MaterialDetailsView from '@/views/general/warehouse/materialsManagement/MaterialDetailsView.vue';
import DeviceDetailsView from '@/views/general/documents/devicesManagement/DeviceDetailsView.vue';
import CompetitorMaterialsView from '@/views/general/traders/CompetitorMaterialsView.vue';
import CompetitorMaterialsWizardView from '@/views/general/traders/CompetitorMaterialsWizardView.vue';
import CustomerDetailsView from '@/views/general/traders/CustomerDetailsView.vue';
import TraderSitesView from '@/views/general/traders/traderSites/TraderSitesView.vue';
import TraderSiteDetailsView from '@/views/general/traders/traderSites/TraderSiteDetailsView.vue';
import CustomersView from '@/views/general/traders/CustomersView.vue';
import DeliveryTypesView from '@/views/general/documents/DeliveryTypesView.vue';
import DocumentSeriesView from '@/views/general/documents/documentSeriesManagement/DocumentSeriesView.vue';
import CompetitorDetailsView from '@/views/general/traders/CompetitorDetailsView.vue';
import MissedVisitsReasonsView from '@/views/general/routes/MissedVisitsReasonsView.vue';
import CompetitorsView from '@/views/general/traders/CompetitorsView.vue';
import DocumentTypesDetailsView from '@/views/general/documents/documentTypesManagement/DocumentTypesDetailsView.vue';
import GroupingView from '@/views/general/grouping/GroupingView.vue';
import ActionManagementView from '@/views/salesSupervision/questionnaires/ActionManagementView.vue';
import SalespersonsHierarchyView from '@/views/general/routes/SalespersonsHierarchyView.vue';
import SalespersonTypesView from '@/views/general/routes/SalespersonTypesView.vue';
import SalesAreasView from '@/views/general/routes/SalesAreasView.vue';
import PriceCollectionLastVisitValuesView from '@/views/salesSupervision/priceCollection/PriceCollectionLastVisitValuesView.vue';
import SalespersonsManagementView from '@/views/general/routes/SalespersonsManagementView.vue';
import VisitPlansView from '@/views/general/routes/VisitPlansView.vue';
import DocumentsManagementView from '@/views/salesSupervision/priceCollection/DocumentsManagementView.vue';
import RoutesManagementView from '@/views/general/routes/routesManagement/RoutesManagementView.vue';
import RouteTraderSitesView from '@/views/general/routes/routesManagement/RouteTraderSitesView.vue';
import DocumentsManagementDetailsView from '@/views/salesSupervision/priceCollection/DocumentsManagementDetailsView.vue';
import QuestionnairesManagementView from '@/views/salesSupervision/questionnaires/QuestionnairesManagementView.vue';
import QuestionnairesDetailsView from '@/views/salesSupervision/questionnaires/QuestionnairesDetailsView.vue';
import QuestionDetailsView from '@/views/salesSupervision/questionnaires/QuestionDetailsView.vue';
import PriceCatalogsView from '@/views/general/prices/PriceCatalogsView.vue';
import PricePoliciesView from '@/views/general/prices/PricePoliciesView.vue';
import PriceCatalogsDetailsView from '@/views/general/prices/PriceCatalogsDetailsView.vue';
import ReportsAnswersView from '@/views/salesSupervision/questionnaires/ReportsAnswersView.vue';
import RoleDetails from '@/views/settings/RoleDetails.vue';
import ReportsAnswersDetailsView from '@/views/salesSupervision/questionnaires/ReportsAnswersDetailsView.vue';
import UserDetails from '@/views/settings/UserDetails.vue';
import MyAccount from '@/views/settings/MyAccount.vue';
import UsersManagement from '@/views/settings/UsersManagement.vue';
import RolesManagement from '@/views/settings/RolesManagement.vue';
import SettingsInstallation from '@/views/settings/SettingsInstallation.vue';
import PriceCatalogDiscountMatrixDetailsView from '@/views/general/prices/PriceCatalogDiscountMatrixDetailsView.vue';
import AppPreferences from '@/views/settings/AppPreferences.vue';
import DocumentSeriesDetailsView from '@/views/general/documents/documentSeriesManagement/DocumentSeriesDetailsView.vue';
import WarehouseManagementView from '@/views/general/warehouse/WarehouseManagementView.vue';
import SalesDocumentsView from '@/views/transactions/SalesDocumentsView.vue';
import VatCategoriesView from '@/views/general/prices/VatCategoriesView.vue';
import VatLevelsView from '@/views/general/prices/VatLevelsView.vue';
import VatFactorsView from '@/views/general/prices/VatFactorsView.vue';
import SalesDocumentDetailsView from '@/views/transactions/SalesDocumentDetailsView.vue';
import RouteDefinitionsView from '@/views/general/routes/RouteDefinitionsView.vue';
import TradersView from '@/views/general/traders/TradersView.vue';
import TraderDetailsView from '@/views/general/traders/TraderDetailsView.vue';
import RangesView from '@/views/general/warehouse/RangesView.vue';
import { useStateStore } from '@/stores/state';
import RangeDetailsView from '@/views/general/warehouse/RangeDetailsView.vue';
import SalesPersonDetailsView from '@/views/general/routes/SalesPersonDetailsView.vue';
import ReportingTemplatesView from '@/views/reporting/ReportingTemplatesView.vue';
import ReportingDesignerView from '@/views/reporting/ReportingDesignerView.vue';
import RepresentativesView from '@/views/general/representatives/RepresentativesView.vue';
import RepresentativesDetailsView from '@/views/general/representatives/RepresentativesDetailsView.vue';
import TransactionsView from '@/views/general/representatives/TransactionsView.vue';
import TransactionsDetailsView from '@/views/general/representatives/TransactionsDetailsView.vue';
import DistributionChannelsView from '@/views/general/documents/distributionChannelsManagement/DistributionChannelsView.vue';
import DistributionChannelsDetailsView from '@/views/general/documents/distributionChannelsManagement/DistributionChannelsDetailsView.vue';
import { Users } from '@/utils/constants';
import ValidationLoggerView from '@/views/general/prices/ValidationLoggerView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView,
      meta: { authLayout: true },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: { requiresAuth: true, layout: 'default' },
    },
    {
      path: '/alter-code-types',
      name: 'alter-code-types',
      component: AlterCodeTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/materials-management',
      name: 'materials-management',
      component: MaterialsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/materials-management/:id',
      name: 'materials-management-preview',
      component: MaterialDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/competitor-types',
      name: 'competitor-types',
      component: CompetitorTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/competitor-materials',
      name: 'competitor-materials',
      component: CompetitorMaterialsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/representatives',
      name: 'representatives',
      component: RepresentativesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/representatives-transactions',
      name: 'representatives-transactions',
      component: TransactionsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/representatives-transactions/:id',
      name: 'representatives-transactions-details',
      component: TransactionsDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/representatives/:id',
      name: 'representatives-details',
      component: RepresentativesDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/competitor-materials/wizard',
      name: 'competitor-materials-wizard',
      component: CompetitorMaterialsWizardView,
      meta: { requiresAuth: true },
    },
    {
      path: '/report-pricing',
      name: 'report-pricing',
      component: ReportPricingView,
      meta: { requiresAuth: true },
    },
    {
      path: '/assortments-management',
      name: 'assortments-management',
      component: AssortmentsManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/assortments-management/details/:id',
      name: 'assortment-details',
      component: AssortmentDetails,
      meta: { requiresAuth: true },
    },
    {
      path: '/settings/my-account',
      name: 'my-account',
      component: MyAccount,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/settings/user-management',
      name: 'user-management',
      component: UsersManagement,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/settings/roles-management',
      name: 'roles-management',
      component: RolesManagement,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/settings/user/:id',
      name: 'UserDetails',
      component: UserDetails,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/settings/installation',
      name: 'settings-installation',
      component: SettingsInstallation,
      meta: { settingsLayout: true, requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/settings/role/:id',
      name: 'RoleDetails',
      component: RoleDetails,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/settings/app-preferences',
      name: 'app-preferences',
      component: AppPreferences,
      meta: { settingsLayout: true, requiresAuth: true },
    },
    {
      path: '/divisions',
      name: 'divisions',
      component: DivisionsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/document-statuses',
      name: 'document-statuses',
      component: DocumentStatusesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/document-types',
      name: 'document-types',
      component: DocumentTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/document-types/:id',
      name: 'document-types-details',
      component: DocumentTypesDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/payment-types',
      name: 'payment-types',
      component: PaymentTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/devices',
      name: 'devices',
      component: DevicesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/devices/:id',
      name: 'device-details',
      component: DeviceDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/mydata',
      name: 'mydata',
      component: MyDataDocumentsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/customers',
      name: 'customers',
      component: CustomersView,
      meta: { requiresAuth: true },
    },
    {
      path: '/customers/:id',
      name: 'customers-preview',
      component: CustomerDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/competitors',
      name: 'competitors',
      component: CompetitorsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/competitors/:id',
      name: 'competitors-preview',
      component: CompetitorDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/delivery-types',
      name: 'delivery-types',
      component: DeliveryTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/document-series',
      name: 'document-series',
      component: DocumentSeriesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/document-series/:id',
      name: 'document-series-details',
      component: DocumentSeriesDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/missed-visits-reasons',
      name: 'missed-visits-reasons',
      component: MissedVisitsReasonsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/trader-sites',
      name: 'trader-sites',
      component: TraderSitesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/trader-sites/:id',
      name: 'trader-sites-preview',
      component: TraderSiteDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/grouping/:category',
      name: 'grouping',
      component: GroupingView,
      meta: { requiresAuth: true },
    },
    {
      path: '/qst-actions',
      name: 'qst-actions',
      component: ActionManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/salespersons-hierarchy',
      name: 'salespersons-hierarchy',
      component: SalespersonsHierarchyView,
      meta: { requiresAuth: true },
    },
    {
      path: '/salespersons-types',
      name: 'salespersons-types',
      component: SalespersonTypesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/sales-areas',
      name: 'sales-areas',
      component: SalesAreasView,
      meta: { requiresAuth: true },
    },
    {
      path: '/routes',
      name: 'routes-management',
      component: RoutesManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/route-details/:id',
      name: 'route-details',
      component: RouteTraderSitesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/route-definitions',
      name: 'route-definitions',
      component: RouteDefinitionsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/visit-plans',
      name: 'visit-plans',
      component: VisitPlansView,
      meta: { requiresAuth: true },
    },
    {
      path: '/price-collection-last-visit-values',
      name: 'price-collection-last-visit-values',
      component: PriceCollectionLastVisitValuesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/salespersons-management',
      name: 'salespersons-management',
      component: SalespersonsManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/salespersons-management/:id',
      name: 'salespersons-management-details',
      component: SalesPersonDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/documents-management',
      name: 'documents-management',
      component: DocumentsManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/documents-management/:id',
      name: 'documents-management-details',
      component: DocumentsManagementDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/questionnaires-management',
      name: 'questionnaires-management',
      component: QuestionnairesManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/questionnaires-management/:id',
      name: 'questionnaires-management-details',
      component: QuestionnairesDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/questionnaires-management/:id/question/:qid',
      name: 'questions-details',
      component: QuestionDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/price-catalogs',
      name: 'price-catalogs',
      component: PriceCatalogsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/price-policies',
      name: 'price-policies',
      component: PricePoliciesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/price-catalogs/:id',
      name: 'price-catalog-details',
      component: PriceCatalogsDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/price-policies/matrix/:id',
      name: 'price-policies-matrix-details',
      component: PriceCatalogDiscountMatrixDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/questionnaires-report',
      name: 'questionnaires-report',
      component: ReportsAnswersView,
      meta: { requiresAuth: true },
    },
    {
      path: '/questionnaires-report/:id',
      name: 'questionnaires-report-details',
      component: ReportsAnswersDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/warehouses',
      name: 'warehouses-management',
      component: WarehouseManagementView,
      meta: { requiresAuth: true },
    },
    {
      path: '/dynamic-ranges',
      name: 'dynamic-ranges',
      component: DynamicRangesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/transactions/sales-documents',
      name: 'sales-documents',
      component: SalesDocumentsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/transactions/sales-documents/:id',
      name: 'sales-documents-details',
      component: SalesDocumentDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/vat-categories',
      name: 'vat-categories',
      component: VatCategoriesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/vat-levels',
      name: 'vat-levels',
      component: VatLevelsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/vat-factors',
      name: 'vat-factors',
      component: VatFactorsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/traders',
      name: 'traders',
      component: TradersView,
      meta: { requiresAuth: true },
    },
    {
      path: '/traders/:id',
      name: 'traders-preview',
      component: TraderDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/ranges-management',
      name: 'ranges-management',
      component: RangesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/ranges/:id',
      name: 'ranges-details',
      component: RangeDetailsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: ReportingTemplatesView,
      meta: { requiresAuth: true },
    },
    {
      path: '/reporting-designer/:id',
      name: 'reporting-designer',
      component: ReportingDesignerView,
      meta: { requiresAuth: true },
    },
    {
      path: '/validation-logger',
      name: 'validation-logger',
      component: ValidationLoggerView,
      meta: { requiresAuth: true },
    },
    {
      path: '/distribution-channels',
      name: 'distribution-channels',
      component: DistributionChannelsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/distribution-channels/:id',
      name: 'distribution-channels-details',
      component: DistributionChannelsDetailsView,
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const { clearTableSelectedPage } = useStateStore();

  const { isSessionValid, username } = storeToRefs(useAuthStore());
  const toastStore = useToastStore();

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    isSessionValid.value = await pingServer();

    if (!isSessionValid.value) {
      next('/');
    } else if (
      to.matched.some((record) => record.meta.requiresAdmin) &&
      username.value !== Users.Admin
    ) {
      toastStore.error({
        text: `${i18n.global.t('messages.errors.access')}`,
      });
      next(false);
    } else {
      const fromPath = from.path;
      const toPath = to.path;
      const sameBase =
        fromPath === toPath ||
        fromPath.startsWith(toPath + '/') ||
        toPath.startsWith(fromPath + '/');
      if (!sameBase) {
        clearTableSelectedPage();
      }
      next();
    }
  } else {
    next();
  }
});

export default router;
